import * as z from "zod";

export const searchRecognizeAudienceProductTitles = {
  name: "searchRecognizeAudienceProductTitles" as const,
  input: z.object({ search: z.string().max(200) }),
  output: z.array(z.string()),
};
